import { theme } from "../ContractDetail/theme";

export const t = theme;

// Hover/focus states the design specifies, which inline styles can't express.
// Scoped under .cw2 so nothing leaks outside the wizard.
export const scopedCss = `
.cw2 { font-family: inherit; color: ${t.text}; }
.cw2 .cw2-btn:hover:not(:disabled) { border-color: ${t.borderHover} !important; }
.cw2 .cw2-primary:hover:not(:disabled) { background: ${t.accentHover} !important; }
.cw2 .cw2-danger-hover:hover { color: ${t.dangerText} !important; border-color: #f0c9c7 !important; }
.cw2 .cw2-row:hover:not(:disabled) { background: ${t.accentSoftBg} !important; }
.cw2 .cw2-chip:hover { border-color: ${t.accent} !important; }
.cw2 .cw2-dashed:hover { background: ${t.accentSoftBg} !important; }
.cw2 input:focus, .cw2 select:focus, .cw2 textarea:focus { border-color: ${t.accent} !important; outline: none; box-shadow: none; }
.cw2 * { box-sizing: border-box; }
`;

export const label = {
  display: "flex",
  alignItems: "center",
  gap: 7,
  fontSize: 12,
  fontWeight: 600,
  color: "#3c3c46",
  marginBottom: 6,
};

export const required = <span style={{ color: t.dangerText }}>*</span>;

export const input = (border = "#dcdce3") => ({
  width: "100%",
  fontSize: 13.5,
  padding: "10px 11px",
  border: `1px solid ${border}`,
  borderRadius: 9,
  outline: "none",
  background: "#fff",
  color: t.text,
});

export const smallInput = (border = "#dcdce3", extra = {}) => ({
  width: "100%",
  height: 34,
  fontSize: 13,
  padding: "0 9px",
  border: `1px solid ${border}`,
  borderRadius: 8,
  outline: "none",
  background: "#fff",
  color: t.text,
  ...extra,
});

export const btn = {
  font: "inherit",
  fontSize: 13,
  fontWeight: 600,
  padding: "9px 15px",
  borderRadius: 9,
  border: "1px solid #dcdce3",
  background: "#fff",
  color: t.text,
  cursor: "pointer",
};

export const primaryBtn = {
  ...btn,
  border: "1px solid transparent",
  background: t.accent,
  color: "#fff",
};

export const card = {
  border: `1px solid ${t.border}`,
  borderRadius: 12,
  overflow: "hidden",
};

export const cardHead = {
  padding: "11px 14px",
  background: t.surfaceSubtle,
  borderBottom: "1px solid #eeeef2",
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: 0.8,
  textTransform: "uppercase",
  color: t.textSecondary,
};

export const tag = (bg, fg) => ({
  fontSize: 10,
  fontWeight: 650,
  padding: "1px 6px",
  borderRadius: 4,
  background: bg,
  color: fg,
});

export const fromDocTag = tag("#eceafd", t.accent);
export const notInDocTag = tag("#fdf7e7", "#8a6b12");

export const tabular = { fontVariantNumeric: "tabular-nums" };
export const muted = { fontSize: 11.5, color: "#6f6f7c" };
